/**
 * Leaves the storefront for another site — the dealer cabinet, the Telegram mini-app — in place of
 * the page on screen, so Back does not return to it. A function of its own because a page load is
 * the one thing jsdom cannot do: the specs put a spy here.
 */
export const leaveSiteFor = (url: string): void => window.location.replace(url);
